export default __webpack_public_path__ + "static/media/JSS.af9c97a8.png";